import { ThemeDefinition } from 'vuetify';

const dark: ThemeDefinition = {
  dark: true,
  colors: {
    background: '#2C2C2D',
    surface: '#000000',
    primary: '#024F56',
    secondary: '#C7D2D6',
    accent: '#FBFF17',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
};

const light: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#F6F9FC',
    surface: '#FFFFFF',
    primary: '#024F56',
    secondary: '#C7D2D6',
    accent: '#FBFF17',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
};

export default {
  // global theme for the app
  globalTheme: 'light', // light | dark

  // wrap pages content with a max-width
  isContentBoxed: true,

  // dark theme colors
  dark,

  // light theme colors
  light,
};
